// v4.9 — Partage d'un catalogue sur les réseaux sociaux (le lien ouvre le catalogue public).
import { Share2, Copy, MessageCircle, Facebook, Music2 } from "lucide-react";
import { toast } from "sonner";
import { trackCatalog } from "@/lib/catalogTracking";

export const ShareSheet = ({ catalog, onClose }) => {
  if (!catalog) return null;
  const base = `${window.location.origin}/kiosque/catalogue/${catalog.catalogId}`;
  const msg = `🏪 ${catalog.merchantName} — ${catalog.title}\nDécouvre mon catalogue sur AYA :`;
  const track = (src) => trackCatalog("catalog_share", { catalog_id: catalog.catalogId, merchant_id: catalog.merchantId, src });

  const copyFor = async (src, hint) => {
    const text = `${base}?src=${src}`;
    try {
      if (navigator.clipboard?.writeText) await navigator.clipboard.writeText(text);
      else {
        const ta = document.createElement("textarea");
        ta.value = text; document.body.appendChild(ta); ta.select();
        document.execCommand("copy"); document.body.removeChild(ta);
      }
      toast.success(hint); track(src);
    } catch { window.prompt("Copie le lien :", text); track(src); }
  };

  const Row = ({ icon, label, sub, onClick, testid }) => (
    <button onClick={onClick} data-testid={testid} className="w-full flex items-center gap-3 rounded-2xl bg-white/[0.05] border border-white/10 hover:border-white/25 px-3.5 py-3 text-left transition-colors">
      <div className="w-9 h-9 rounded-xl bg-white/[0.07] flex items-center justify-center shrink-0">{icon}</div>
      <div className="flex-1 min-w-0">
        <div className="text-[12.5px] font-bold">{label}</div>
        {sub && <div className="text-[10.5px] text-white/45">{sub}</div>}
      </div>
    </button>
  );

  return (
    <div className="fixed inset-0 z-50 flex items-end sm:items-center sm:justify-center" data-testid="share-sheet">
      <div className="absolute inset-0 bg-black/70" onClick={onClose} />
      <div className="relative w-full sm:max-w-md bg-[#111116] border-t sm:border border-white/12 rounded-t-3xl sm:rounded-3xl p-5 space-y-2.5">
        <div className="text-[14px] font-extrabold flex items-center gap-2"><Share2 size={16} className="text-amber-300" /> Partager « {catalog.title} »</div>
        <div className="text-[11px] text-white/50 pb-1">Le lien ouvre directement ton catalogue — tes clients peuvent le feuilleter et voir tes produits.</div>
        <Row icon={<MessageCircle size={17} className="text-emerald-400" />} label="WhatsApp" sub="Statut, groupes ou clients"
          testid="share-whatsapp"
          onClick={() => { track("whatsapp"); window.open(`https://wa.me/?text=${encodeURIComponent(`${msg} ${base}?src=whatsapp`)}`, "_blank"); }} />
        <Row icon={<Facebook size={17} className="text-blue-400" />} label="Facebook" sub="Publier sur ta page ou ton profil"
          testid="share-facebook"
          onClick={() => { track("facebook"); window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(`${base}?src=facebook`)}`, "_blank"); }} />
        <Row icon={<Music2 size={17} className="text-pink-400" />} label="TikTok / Instagram" sub="Copie le lien pour ta bio ou ta description"
          testid="share-tiktok"
          onClick={() => copyFor("tiktok", "Lien copié 📋 Colle-le dans ta bio ou description TikTok/Instagram")} />
        <Row icon={<Copy size={17} className="text-white/70" />} label="Copier le lien" sub={`${base.slice(0, 46)}…`}
          testid="share-copy"
          onClick={() => copyFor("link", "Lien copié 📋")} />
        {typeof navigator !== "undefined" && navigator.share && (
          <Row icon={<Share2 size={17} className="text-amber-300" />} label="Plus d'options" sub="Partage via ton téléphone"
            testid="share-native"
            onClick={() => { track("native"); navigator.share({ title: catalog.title, text: msg, url: `${base}?src=share` }).catch(() => {}); }} />
        )}
        <button onClick={onClose} data-testid="share-close" className="w-full rounded-xl border border-white/15 text-white/70 font-bold text-[12.5px] py-2.5 mt-1">Fermer</button>
      </div>
    </div>
  );
};
